import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @atlaskit/ui-styling-standard/no-global-styles -- See https://product-fabric.atlassian.net/browse/EDF-2406
import { css, Global } from '@emotion/react';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/ensure-design-token-usage -- Ignored via go/DSP-18766
const aiDefinitionsStyle = css({
	// eslint-disable-next-line  @atlaskit/ui-styling-standard/no-nested-selectors
	'.ai-definitions-keyword-decoration': {
		position: 'relative',
		cursor: 'pointer',
	},
	// eslint-disable-next-line  @atlaskit/ui-styling-standard/no-nested-selectors
	'.ai-definitions-keyword-styler': {
		'--ai-definitions-keyword-styler-width': 0,
		'--ai-definitions-keyword-styler-height': 0,
		position: 'relative',

		'&::after': {
			content: "' '",
			position: 'absolute',
			top: 0,
			right: 0,
			width: 'var(--ai-definitions-keyword-styler-width)',
			height: 'var(--ai-definitions-keyword-styler-height)',
			cursor: 'pointer',
			pointerEvents: 'none',
			paddingBottom: token('space.025', '2px'),
			borderImage: 'linear-gradient(to right, #0065ff, #bf63f3, #f5e6a8) 0 0 100% 0',
			borderWidth: '2px',
			borderBottomStyle: 'solid',
		},

		// eslint-disable-next-line  @atlaskit/ui-styling-standard/no-nested-selectors
		'&-hover, &-active': {
			'&::after': {
				// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
				background: 'linear-gradient(to right, rgba(0, 101, 255, 0.1), rgba(191, 99, 243, 0.1))',
			},
		},
	},
});

export function AIDefinitionsGlobalStyles() {
	return <Global styles={aiDefinitionsStyle} />;
}
